import { useTranslation } from 'react-i18next';

import { Header } from 'features/my-profile/components/Header';
import { ReturnFromProfileButton } from 'features/my-profile/components/ReturnFromProfileButton';

import { AccountSettings } from './components/AccountSettings';

export const AccountSettingsPage = () => {
  const { t } = useTranslation('myProfile');

  return (
    <div data-testid={'my-profile-account-settings'}>
      <ReturnFromProfileButton />
      <Header data-testid={'account-settings-page-header'}>{t('account-settings.header')}</Header>
      <AccountSettings />
    </div>
  );
};
